// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-modal[data-v-26fc232a]  .modal-container{width:600px}.custom-modal[data-v-26fc232a]  .modal-body{margin:24px 16px 48px 16px;padding:0}.custom-modal[data-v-26fc232a]  .modal-header{padding-top:6px}", ""]);
// Exports
module.exports = exports;
